<template>
  <el-dialog :title="$t('newAgent')" :visible="isShowDialog" @close="closePopup()" width="600px">
    <span id="modal-body">
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('agentName')" :required="true">
          <el-input v-model="agent.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('type')">
          <el-select v-model="agent.agentTypeId" placeholder="-">
            <el-option :label="agentType.name" :value="agentType.id" v-for="agentType in agentTypeList" :key="agentType.id"></el-option>
            <el-option :label="$t('otherType')" :value="AGENT_TYPE.OTHER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" " v-if="agent.agentTypeId === AGENT_TYPE.OTHER" :required="true">
          <el-input v-model="agent.agentTypeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="agent.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onAddAgentButtonClick">{{ $t('create') }}</el-button>
      <el-button type="default" @click="closePopup">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { STATUS, AGENT_TYPE } from '@/configs/constant'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import AgentApi from '@/api/agent-api'
import i18nMessages from '@/translations/Agent/components/PopupAddAgent.i18n'

export default {
  name: 'PopupAddAgent',
  i18n: { messages: i18nMessages },
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agentTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      STATUS,
      AGENT_TYPE,
      agent: {
        name: '',
        agentTypeId: '',
        agentTypeName: '',
        isEnable: STATUS.ENABLE
      },
      isShowDialog: false
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    }
  },
  methods: {
    onAddAgentButtonClick: async function () {
      try {
        this.startLoading()

        const agent = await AgentApi.create(this.agent)
        const event = this._addAgentSuccess(agent)

        const title = this.$t('createAgentSuccessTitle')
        const message = this.$t('createAgentSuccessMessage')

        this.$emit('onAdded', event)
        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.closePopup()
      this.clear()
      this.stopLoading()
    },
    _addAgentSuccess: function (agent) {
      let result = {
        agent: agent
      }

      if (this.agent.agentTypeId !== AGENT_TYPE.OTHER) {
        return result
      }

      const agentType = {
        agentType: {
          id: agent.agentTypeId,
          name: this.agent.agentTypeName
        }
      }

      result = Object.assign({}, result, agentType)

      return result
    },
    closePopup: function () {
      this.isShowDialog = false
      this.$emit('onClose')
    },
    clear: function () {
      this.agent.name = ''
      this.agent.agentTypeId = ''
      this.agent.agentTypeName = ''
      this.agent.isEnable = 1
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
